import { render } from "./HeadingTitle.vue?vue&type=template&id=7632420e"
import script from "./HeadingTitle.vue?vue&type=script&lang=js"
export * from "./HeadingTitle.vue?vue&type=script&lang=js"

import "./HeadingTitle.vue?vue&type=style&index=0&id=7632420e&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__